import { round4 } from 'utilities/math';
import isArray from 'lodash/isArray';
import { values } from 'lodash';

export const getLevelLikeObject = levels => levels.reduce((previous, current) => ({
  ...previous,
  [current.name]: current
}), {});

export const getRelativeFrequencySammaryByFrequencySummary = frequencySummary => {

  const total = round4(frequencySummary.reduce((sum, item) => sum + item.count, 0));

  return frequencySummary.map(item => {
    const levels = isArray(item.levels) ? item.levels : values(item.levels);
    const levelsLikeArray = levels.map(level => {
      return ({
        ...level,
        count: round4(level.count / total)
      });
    });

    const levelLikeObject = getLevelLikeObject(levelsLikeArray);
    return ({
      ...item,
      count: round4(item.count / total),
      levels: item.levels ? levelLikeObject : {}
    });
  });
};

export const getObjectByArray = levels =>
  levels.map(item => {
    const level = item.levels;
    if (level && Array.isArray(level)) {
      return ({
        ...item,
        levels: getLevelLikeObject(level)
      });
    }
    return item;
  });
